export default __webpack_public_path__ + "static/media/cover-pic.b5939f2f.png";